import { AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Badge } from '@/components/ui/badge';
import { type BatonWarning } from '@/lib/queries';
import { warningLabel } from '@/lib/baton-format';

/**
 * Renders a baton's low-resource warnings (brief 115). `compact` (the
 * Batons-list row) shows a single amber badge with a `title` listing the
 * labels; the full form (the detail Overview tab) shows an Alert with the
 * list. The warning codes + thresholds are computed server-side.
 */
export function BatonWarnings({
  warnings,
  compact,
  className,
}: {
  warnings: BatonWarning[] | undefined;
  compact?: boolean;
  className?: string;
}) {
  if (!warnings || warnings.length === 0) return null;
  const labels = warnings.map((w) => warningLabel(w.code));

  if (compact) {
    return (
      <Badge
        variant="outline"
        className={`gap-1 border-amber-500 text-amber-600 ${className ?? ''}`}
        title={labels.join(', ')}
      >
        <AlertTriangle className="h-3 w-3" /> {warnings.length}
      </Badge>
    );
  }

  return (
    <Alert className={`border-amber-500 ${className ?? ''}`}>
      <AlertTitle className="flex items-center gap-2 text-amber-600">
        <AlertTriangle className="h-4 w-4" /> Low resources
      </AlertTitle>
      <AlertDescription>
        <ul className="mt-1 list-inside list-disc text-sm">
          {warnings.map((w) => (
            <li key={w.code}>{warningLabel(w.code)}</li>
          ))}
        </ul>
      </AlertDescription>
    </Alert>
  );
}
